import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../utils/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const response = await apiFetch("/api/auth/session", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: sessionId })
          });

          if (response.ok) {
            const data = await response.json();
            login(data.user, data.token);
            const destination = data.user?.role === 'coach' ? '/coach-dashboard' : '/dashboard';
            navigate(destination, { replace: true });
            return;
          }
        } catch (error) {
          console.error('Auth callback error:', error);
        }
      }
      navigate('/login', { replace: true });
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="loading" style={{ minHeight: '100vh' }}>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default AuthCallback;
